import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
import './RuleStrategyPage.css';
import RefreshButton from './RefreshButton';
import WatchlistStar from './WatchlistStar';

const RuleStrategyPage = ({ onBack }) => {
  const [direction, setDirection] = useState('ALL');
  const [topPerformers, setTopPerformers] = useState([]);
  const [lowPerformers, setLowPerformers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    setError('');
    
    fetch(`${API_BASE_URL}/breakout-three-percent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: 'fo' })
    })
    .then(response => response.json())
    .then(data => {
      setTopPerformers(data.data?.top_performers || []);
      setLowPerformers(data.data?.low_performers || []);
    })
    .catch(err => {
      setError('Failed to load data');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const filteredTop = topPerformers.filter(stock => stock.percentage_change >= 0);
  const filteredLow = lowPerformers.filter(stock => stock.percentage_change < 0);
  const showTop = direction === 'ALL' || direction === 'UP';
  const showLow = direction === 'ALL' || direction === 'DOWN';

  return (
    <div className="rule-strategy-page">
      <header className="rule-strategy-header">
        <div className="rule-strategy-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" alt="Stocks4U" />
          </div>
          <div className="rule-strategy-user">
            <RefreshButton onRefresh={fetchData} isLoading={loading} />
          </div>
        </div>
      </header>

      <main className="rule-strategy-main">
        <div className="rule-strategy-container">
          <div className="s4u-title-row">
            <div className="s4u-page-heading">
              <button className="rule-strategy-back-btn s4u-back-btn" onClick={onBack}>
                ← Back to Dashboard
              </button>
              <h1>Momentum Radar</h1>
            </div>
          </div>

          <div className="spike-section">
            <h4>3% RULE STRATEGY</h4>
            <div className="strategy-buttons">
              <button 
                className={`btn green-btn ${direction === 'UP' ? 'active' : ''}`}
                onClick={() => setDirection('UP')}
              >
                UP
              </button>
              <button 
                className={`btn red-btn ${direction === 'DOWN' ? 'active' : ''}`}
                onClick={() => setDirection('DOWN')}
              >
                DOWN
              </button>
              <button 
                className={`btn gray-btn ${direction === 'ALL' ? 'active' : ''}`}
                onClick={() => setDirection('ALL')}
              >
                ALL
              </button>
            </div>
          </div>

          <div className="rule-strategy-table-container">
            {/* Results count always visible */}
            <div className="results-count">
              Showing {filteredTop.length + filteredLow.length} results ({direction.toUpperCase()})
            </div>

            <div className="rule-strategy-table">
              {/* ✅ LOADING OVERLAY INSIDE TABLE */}
              {loading && (
                <div className="table-loading-overlay">
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                </div>
              )}
              
              {/* ✅ ERROR INSIDE TABLE */}
              {error && !loading && (
                <div className="table-error">
                  <div className="error-message">{error}</div>
                </div>
              )}

              {/* ✅ TABLE CONTENT - Only when NOT loading */}
              {!loading && !error && (
                <>
                  {showTop && filteredTop.length > 0 && (
                    <>
                      <h3>Top Performers ({filteredTop.length})</h3>
                      <div className="table-row table-header-row">
                        <div className="table-cell">Stock</div>
                        <div className="table-cell">LTP</div>
                        <div className="table-cell">% Change</div>
                        <div className="table-cell">Proximity to High</div>
                      </div>
                      {filteredTop.map((stock, i) => (
                        <div key={i} className="table-row">
                          <div className="table-cell">
                            <WatchlistStar stock={stock} size="16px" />
                            {stock.stock}
                          </div>
                          <div className="table-cell">{stock.ltp}</div>
                          <div className="table-cell positive">{stock.percentage_change}%</div>
                          <div className="table-cell">{stock.proximity_to_high}</div>
                        </div>
                      ))}
                    </>
                  )}

                  {showLow && filteredLow.length > 0 && (
                    <>
                      <h3>Low Performers ({filteredLow.length})</h3>
                      <div className="table-row table-header-row">
                        <div className="table-cell">Stock</div>
                        <div className="table-cell">LTP</div>
                        <div className="table-cell">% Change</div>
                        <div className="table-cell">Proximity to Low</div>
                      </div>
                      {filteredLow.map((stock, i) => (
                        <div key={i} className="table-row">
                          <div className="table-cell">
                            <WatchlistStar stock={stock} size="16px" />
                            {stock.stock}
                          </div>
                          <div className="table-cell">{stock.ltp}</div>
                          <div className="table-cell negative">{stock.percentage_change}%</div>
                          <div className="table-cell">{stock.proximity_to_low}</div>
                        </div>
                      ))}
                    </>
                  )}

                  {/* ✅ EMPTY STATE INSIDE TABLE */}
                  {(!showTop || filteredTop.length === 0) && 
                   (!showLow || filteredLow.length === 0) && (
                    <div className="table-empty-state">
                      No stocks match "{direction}" filter
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RuleStrategyPage;
